import {
  IMAGE_UPLOAD_AVATAR_URL,
  IMAGE_UPLOAD_DOCUMENT_URL,
  IMAGE_UPLOAD_URL,
} from '@config/urls';
import { ErrorCategory, handleError } from '@services/errorService';
import { getActiveSessionToken } from '@services/sessionToken';

const URL = IMAGE_UPLOAD_URL;
const URL_UPLOAD_AVATAR = IMAGE_UPLOAD_AVATAR_URL;
const URL_UPLOAD_DOCUMENT = IMAGE_UPLOAD_DOCUMENT_URL;

type UploadType =
  | 'user_avatar'
  | 'org_avatar'
  | 'chat'
  | 'chat-document'
  | 'link'
  | 'custom_posts';

const uploadImage = async (
  file: File | Blob | null | undefined,
  uploadType: UploadType = 'user_avatar',
): Promise<string | undefined> => {
  if (!file) {
    return;
  }

  const formData = new FormData();
  formData.append('file', file);

  try {
    const sessionToken = getActiveSessionToken();

    const response = await fetch(
      uploadType === 'user_avatar'
        ? URL_UPLOAD_AVATAR
        : uploadType === 'chat-document'
        ? URL_UPLOAD_DOCUMENT
        : URL,
      {
        method: 'POST',
        headers: {
          ...(sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {}),
          // 'user_avatar', 'org_avatar', 'chat'
          'x-upload-type': uploadType === 'chat-document' ? 'chat' : uploadType,
        },
        body: formData,
      },
    );

    if (response.ok) {
      const result = await response.json();
      return result?.key;
    } else {
      throw new Error('Ошибка при загрузке');
    }
  } catch (error) {
    handleError(error as Error, { category: ErrorCategory.API });
  }
};

export default uploadImage;
